import React from 'react';
import { PoliticsContainer } from './ui';

export const PoliticsScreen: React.FC = () => <PoliticsContainer />;
